import { createSelector } from 'reselect';

export const getQuotes = state => state.quotes.quotes;

export const getQuotesTotalScore = createSelector(
    getQuotes,
    quotes => {
        let total = 0;
        for(let quoteList of quotes) {
            total += quoteList.quotes.reduce( (accumulator, element) => accumulator + element.score, 0)
        }
        return total
    }
);